import styled from 'styled-components';

export const StudentRatingTop = styled.div`
  max-width: 105px;
  margin-bottom: 50px;
`;
